export const TimesheetMethod = Object.freeze({
  /**
   * Client or 'classic' timesheeting. The default timesheet method.
   */
  client: 'client',
  /**
   * Candidate timesheeting. A candidate must submit a shift record before the
   * timesheet can be actioned by the client.
   */
  candidate: 'candidate',
})
